import * as React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import CreditSurvey from "./CreditSurvey";
import { useHistory } from "react-router-dom";

const ReqCredit = ({ passPortal }) => {
  const [loading, setLoading] = useState(true);
  const [survey, setSurvey] = useState(null);
  const [error, setError] = useState(null);
  let history = useHistory();
  const { ap, campaign, user, search, DeviceID } = history.location.state;

  useEffect(() => {
    _fethSurvey();
  }, []);

  const postAnswers = async (survey) => {
    try {
      let answers = survey.questions.map((v) => {
        return {
          store_id: ap.ap_locationid,
          answer: v.answer,
          survey_question_id: v.id,
          user_mac_address: DeviceID,
          survey_id: survey.id
        };
      });
      let fields = {
        user_mac_address: DeviceID,
        store_id: ap.ap_locationid,
        survey_id: survey.id,
        answers,
      };

      await axios.post("/surveys", fields);
      setError(null);
      await postGDRP();
      passPortal(ap, campaign, DeviceID);
      return;
    } catch (error) {
      setError("Ocurrio un error, intenrelo mas tarde");
      return;
    }
  };

  const postGDRP = async () => {
    try {
      let fields = {
        user_mac_address: DeviceID,
        store_id: ap.ap_locationid,
        accept: true,
      };
      await axios.post("/gdpr", fields);
    } catch (error) {
      console.log(error);
      setError("Ocurrio un error, intenrelo mas tarde");
      return;
    }
  };

  const _fethSurvey = async () => {
    try {
      const res = await axios.get("/surveys", {
        params: { survey_id: campaign.survey_id },
      });
      let fields2 = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID,
        CampaignID: campaign.CampaignID,
        MediaType: "survey",
      };
      await axios.post("/impressions", { fields: fields2 });
      let surveysQuestions = [];
      for (const question of res.data.questions) {
        let pregunta: string = question.question.toLowerCase();
        let answer = {
          survey_question_id: question.id,
          store_id: ap.ap_locationid,
          answer: "",
          user_mac_address: DeviceID,
        };
        if (question.question_type === "Multiple selection") {
          answer = {
            ...answer,
            answer: question.posible_answer.split(",")[0],
          };
        } else {
          if (user) {
            answer = {
              ...answer,
              answer:
                pregunta.includes("correo") || pregunta.includes("email")
                  ? user.email
                    ? user.email
                    : ""
                  : question.question_type === "Telephone"
                  ? user.celular
                    ? user.celular.substring(
                        user.celular.length,
                        user.celular.length - 10
                      )
                    : ""
                  : "",
            };
          } else {
            answer = {
              ...answer,
              answer: "",
            };
          }
        }

        let newQuestion = {
          ...question,
          posible_answer: question.posible_answer
            ? question.posible_answer.split(",")
            : [],
          answer,
        };
        surveysQuestions.push(newQuestion);
      }
      console.log(survey);
      setSurvey({
        ...res.data,
        questions: surveysQuestions,
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const postImpressionAction = async(mediaType: string) => {
    try {
      let fields2 = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID,
        CampaignID: campaign.CampaignID,
        MediaType: mediaType,
      };
      await axios.post("/impressions", { fields: fields2 });
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <CreditSurvey
      postAnwers={(s) => postAnswers(s)}
      loading={loading}
      survey={survey}
      user={user}
      passPortal={() => passPortal(ap, campaign, DeviceID)}
      ap={ap}
      device_id={DeviceID.replace(/:/g, "")}
      campaign={campaign}
      postImpression={(media) => postImpressionAction(media)}
    />
  );
};

export default ReqCredit;
